<template>
    <div class="u-max-700 u-center-block">
        <v-loading type="global" :data="User"></v-loading>
        <page-header>
            <slot slot="title">{{ User.FirstName }} {{ User.LastName }}</slot>
        </page-header>

        <!-- PERSONAL -->
        <section class="c-form-row o-page-bottom-spacing--medium">
            <form action="" class="c-form c-form--horizontal">

                <h2 class="c-title--border u-h3">
                    {{ $t('customer.account.edit.form.personal.title') }}
                </h2>

                <v-form-row>
                    <v-input v-model="User.FirstName" name="personal_first_name" :fluid="true" :error="Validate.FirstName">
                        <slot slot="label">{{ $t('users.first_name') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="User.LastName" name="personal_last_name" :fluid="true" :error="Validate.LastName">
                        <slot slot="label">{{ $t('users.last_name') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-custom-select v-model="selectedFunction" 
                                        name="function" 
                                        :options="FunctionOptions" 
                                        :fluid="true" 
                                        option-name="content" 
                                        option-value="value"
                                        track-by="value"
                                        search-label="content">
                        <slot slot="label">{{ $t('customer.account.edit.form.personal.function.label') }}</slot>
                    </v-custom-select>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="User.PhoneNumber" name="personal_phone" type="tel" :fluid="true" :error="Validate.PhoneNumber">
                        <slot slot="label">{{ $t('customer.account.edit.form.personal.phone.label') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="User.Email" name="personal_email" type="email" :fluid="true"
                                :error="Validate.Email">
                        <slot slot="label">{{ $t('customer.account.edit.form.personal.email.label') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="User.SalesTakerCode" name="personal_sales_taker_code" :fluid="true" :error="Validate.SalesTakerCode">
                        <slot slot="label">{{ $t('users.sales_taker_code') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                        <label class="c-label">{{ $t('customer.account.edit.form.personal.profile_picture.label') }}</label>
                        <div class="u-inline-block u-pos-relative" style="width: 200px">
                            <v-picture-input
                                    :width="200"
                                    :height="200"
                                    :selected="User.Photo"
                                    @changed="setProfilePicture">
                            </v-picture-input>
                        </div>
                    </div>
                </v-form-row>

                <v-form-row>
                    <div class="c-form-item c-form-item--horizontal">
                        <v-label></v-label>
                        <button @click.prevent="submitPersonal" class="c-button c-button--alpha">
                            {{ $t('customer.account.edit.form.personal.submit') }}
                        </button>
                    </div>
                </v-form-row>
            </form>
        </section>

    </div>
</template>

<script>
    import VLoading from '@/components/Loading'
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VPictureInput from '@/components/form/PictureInput'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VPictureInput,
            VFormRow,
            VTargetListSelect,
            VSwitch,
            VLoading
        },
        data() {
            return {
                User: {},
                Validate: {},
                FunctionOptions: [
                    {
                        value: 0,
                        content:this.$t('global.purchase')
                    },
                    {
                        value: 1,
                        content: this.$t('global.marketing')
                    },
                    {
                        value: 2,
                        content:this.$t('global.director')
                    },
                    {
                        value: 3,
                        content: this.$t('global.shop_assistant')
                    },
                    {
                        value: 4,
                        content:this.$t('global.accountancy')
                    }
                ],
            }
        },
        created() {
            this.$store.dispatch('getUserById', this.$route.query.id).then(user => {
                this.User = user;
            });
        },
        computed: {
            selectedFunction: {
                get () {
                    let output;
                    output = this.FunctionOptions.find((obj) => {
                        return obj.value === this.User.Function;
                    });

                    if (output) {
                        this.$set(this.User, 'Function', output.value);
                    }

                    return output ? output : { };
                },
                set (value) {
                    this.$set(this.User, 'Function', value.value);
                    return value;
                }
            },          
            sideMenuLinks() {
                let menu = [
                    {
                        title: 'customer.account.edit.title',
                        route: '/customer/account/edit',
                    }
                ];

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.users.title',
                        route: '/customer/account/users'
                    });
                    menu.push({
                        title: 'customer.account.addresses.title',
                        route: '/customer/account/addresses'
                    });
                }

                if(this.isCustomer || this.isMarketing) {
                    menu.push({
                        title: 'customer.account.history.title',
                        route: '/customer/account/history'
                    });

                    menu.push({
                        title: 'customer.account.backorders.title',
                        route: '/customer/account/backorders'
                    })
                }

                return menu;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        },
        methods: {
            validateForm(response) {
                let errors = response;

                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            
            submitPersonal() {
                this.$store.dispatch('sendUser', this.User).then(() => {
                    this.notifySuccess('Persoonlijke gegevens');
                    this.Validate = {};
                });
            },

            setProfilePicture(picture) {
                this.$set(this.User, 'Photo', picture)
            },

            notifySuccess(title) {
                this.$notify({
                    group: 'global',
                    title: title,
                    text: this.$t('global.saved'),
                    type: 'success',
                    duration: 4000
                });
            },
            notifyError(title) {
                this.$notify({
                    group: 'global',
                    title: title,
                    text: this.$t('global.error_occured'),
                    type: 'error',
                    duration: 4000
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/admin/account/EditUser.vue